import React, { useState } from 'react';

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

function JourneyDatePicker({
  currentDate,
  onChange,
  placeholderText = '',
  showTimeSelect = true,
  customInput,
  onClick = () => {},
  isNeue = false,
}) {
  const [date, setDate] = useState(currentDate ? new Date(currentDate) : null);

  const onDateChange = (date) => {
    setDate(date);
    onChange(date);
  };

  return (
    <div className={!isNeue ? 'journey-datepicker' : 'neue-datepicker'} onClick={onClick}>
      <DatePicker
        selected={date}
        onChange={onDateChange}
        showTimeSelect={showTimeSelect}
        timeFormat='HH:mm'
        timeIntervals={15}
        timeCaption='time'
        dateFormat='MMMM d, yyyy h:mm aa'
        minDate={new Date()}
        placeholderText={placeholderText}
        customInput={customInput}
      />
    </div>
  );
}

export default JourneyDatePicker;
